import { render, staticRenderFns } from "./HeaderItem.vue?vue&type=template&id=77f24bf4&scoped=true&"
import script from "./HeaderItem.vue?vue&type=script&lang=js&"
export * from "./HeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./HeaderItem.vue?vue&type=style&index=0&id=77f24bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f24bf4",
  null
  
)

export default component.exports